import { Dispatch, SetStateAction, createContext } from 'react'

export type FilterDate = {
  label?: string
  value?: string
}

export type FilterGroupForDatesContext = {
  onSubmitFilter: (values: any) => void
  filterDate?: FilterDate
  setFilterDate: Dispatch<SetStateAction<FilterDate>>
}

const defaultValues = {
  onSubmitFilter: () => {},
  filterDate: {},
  setFilterDate: () => {},
}

const SidebarContext = createContext<FilterGroupForDatesContext>(defaultValues)

export default SidebarContext
